import {
  deviceAppStoreIcon,
  deviceGoogleIcon,
  deviceLinuxIcon,
  deviceMacIcon,
  deviceWebIcon,
  deviceWindowsIcon,
} from 'assets/images';

export const data = [
  {
    icon: deviceWindowsIcon,
    name: 'Work_all_card_1_',
  },
  {
    icon: deviceMacIcon,
    name: 'Work_all_card_2_',
  },
  {
    icon: deviceGoogleIcon,
    name: 'Work_all_card_3_',
  },
  {
    icon: deviceAppStoreIcon,
    name: 'Work_all_card_4_',
  },
  {
    icon: deviceLinuxIcon,
    name: 'Work_all_card_5_',
  },
  {
    icon: deviceMacIcon,
    name: 'Work_all_card_6_',
  },
  {
    icon: deviceWebIcon,
    name: 'Work_all_card_7_',
  },
];

export const soon = [
  'Soon_card_1_',
  'Soon_card_2_',
  'Soon_card_3_',
  'Soon_card_4_',
];
